import { ErrorPanel } from './ErrorPanel.js';

type Props = {
  title: string;
  progress: number; // 0..1
  step: string;
  detail?: string;
  error?: { code: string; message: string } | null;
  onRetry?: () => void;
};

const STEP_LABEL: Record<string, string> = {
  resolving_title: '查询 TMDB...',
  querying_tmdb: '查询 TMDB...',
  scraping_reviews: '抓取影评...',
  scraping_subtitles: '抓取字幕...',
  analyzing_word_frequency: '词频分析...',
  writing_session: '准备词库...',
};

const ERROR_HEADLINE: Record<string, string> = {
  movie_not_found: '没找到这个标题，换个写法试试',
  subtitle_not_found: '这一集没找到字幕',
  insufficient_text: '抓到的文本太短，换一部试试',
  no_sources: '所有信息源都没返回内容',
  tmdb_api_error: 'TMDB 暂时不可用，请稍后再试',
  bad_request: '输入有问题',
  server_error: '服务器报错，稍后再试',
};

function pickStepText(step: string, detail?: string): string {
  const base = STEP_LABEL[step] ?? '处理中...';
  if (step === 'scraping_reviews' && detail) return `抓取 ${detail} ...`;
  return base;
}

export function LoadingOverlay({
  title,
  progress,
  step,
  detail,
  error,
  onRetry,
}: Props): JSX.Element {
  const pct = Math.max(0, Math.min(100, Math.round(progress * 100)));
  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 pb-10">
      <div className="w-full max-w-card flex flex-col gap-6">
        <div className="text-primary text-[18px] font-medium text-center">
          正在分析《{title}》
        </div>
        <div className="flex flex-col gap-2">
          <div className="h-1.5 w-full bg-surface-2 rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-[width] duration-300 ease-out"
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="flex justify-between text-secondary text-hint">
            <span>{pickStepText(step, detail)}</span>
            <span>{pct}%</span>
          </div>
        </div>
        {error ? (
          <div className="mt-2">
            <ErrorPanel
              headline={ERROR_HEADLINE[error.code] ?? '抓取失败'}
              detail={`${error.code} · ${error.message}`}
              onRetry={onRetry}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
